import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ComingSoon = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLearnMore = () => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const basePath = pathSegments[0] ? `/${pathSegments[0]}` : "/";
    navigate(basePath);
  };
  return (
    <div className="card flex justify-center-100 items-center justify-center min-h-screen bg-gray-100">
      <div className="flex flex-col justify-center items-center min-h-screen bg-gradient-to-br from-[#fef6e4] via-[#f9f9ff] to-[#e3f2fd] text-center px-4">
        <img
        src="/images/undraw_under-construction_c2y1.png"
        alt="Coming Soon Illustration"
        className="coming-css mb-8 animate-float"
      />
        <h1 className="text-5xl md:text-6xl font-semibold text-gray-900 mb-4">
          Great things coming soon.
        </h1>
       
        <button
          className="submit-btn-more"
           onClick={handleLearnMore}
        ><ArrowBackIcon fontSize="small" />
          Back to Home
        </button>
      </div>
    </div>

  );
};

export default ComingSoon;
